
import React, { useRef } from 'react';
import { useAuth } from '@/contexts/auth';
import GuestNamePrompt from './GuestNamePrompt';
import MessageList from './MessageList';
import MessageInput from './MessageInput';
import { useChatMessages } from './hooks/useChatMessages';
import { useGuestUsername } from './hooks/useGuestUsername';

interface ChatPanelProps {
  tripId: string;
}

const ChatPanel: React.FC<ChatPanelProps> = ({ tripId }) => {
  const { user, isGuest } = useAuth();
  const messageEndRef = useRef<HTMLDivElement>(null);
  
  // Use custom hooks
  const {
    username,
    setUsername,
    isUsernameSaved,
    setIsUsernameSaved,
    handleUsernameSubmit
  } = useGuestUsername(user);
  
  const {
    messages,
    newMessage,
    setNewMessage,
    isLoading,
    isSending,
    handleSendMessage
  } = useChatMessages({ 
    tripId, 
    user, 
    username 
  });

  // Guest name prompt
  if (!user && !isUsernameSaved) {
    return (
      <GuestNamePrompt 
        username={username}
        setUsername={setUsername}
        handleUsernameSubmit={handleUsernameSubmit}
      />
    );
  }
  
  return (
    <div className="flex flex-col h-[600px] max-h-[calc(100vh-250px)]">
      {/* Messages area */}
      <div className="flex-1 overflow-y-auto mb-4 pr-2 space-y-3">
        <MessageList 
          messages={messages}
          user={user}
          isLoading={isLoading}
        />
      </div>
      
      {/* Message input */}
      <div className="mt-auto">
        <MessageInput
          newMessage={newMessage}
          setNewMessage={setNewMessage}
          handleSendMessage={handleSendMessage}
          isSending={isSending}
          user={!!user}
          username={username}
          setIsUsernameSaved={setIsUsernameSaved}
        />
      </div>
    </div>
  );
};

export default ChatPanel;
